/**
 * @desc 安防公告查询
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.AnnouncementNoticeRequest,
): Promise<defs.StandardReturn<defs.Pager<defs.AnnouncementNoticeResponse>>> {
  return defHttp.post({
    url: '/web/announcement/search',
    data,
  });
}

export function mock(
  data: defs.AnnouncementNoticeRequest,
): Promise<defs.StandardReturn<defs.Pager<defs.AnnouncementNoticeResponse>>> {
  return defHttp.post({
    url: '/mock/web/announcement/search',
    data,
  });
}
